import { Star, Quote, ExternalLink } from "lucide-react";
import { reviews, googleReviews } from "../mock/mock";
import CTASection from "../components/CTASection";
import useSeo from "../hooks/useSeo";

const GoogleG = () => (
  <svg viewBox="0 0 48 48" className="w-5 h-5" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

export default function Omdomen() {
  useSeo({ title: "Omdömen", description: "Läs vad våra elever säger om City Trafikskola Uppsala – 4,8 av 5 i betyg på Google baserat på över 250 omdömen." });
  return (
    <main className="pt-20 md:pt-[8.25rem]">
      <section className="bg-[#0B2545] py-20">
        <div className="max-w-7xl mx-auto px-5 text-center">
          <span className="text-[#ffce3a] font-semibold tracking-[0.2em] text-xs uppercase">Omdömen</span>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-white mt-3">Vad våra elever säger</h1>
          <div className="flex flex-wrap items-center justify-center gap-2 mt-5" data-testid="google-rating-summary">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={22} className="text-[#ffce3a] fill-[#ffce3a]" />
              ))}
            </div>
            <span className="text-white font-semibold text-lg ml-2">{googleReviews.rating} av 5</span>
            <span className="text-slate-400">· {googleReviews.count} omdömen på Google</span>
          </div>
          <a
            href={googleReviews.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-link"
            className="inline-flex items-center gap-2 mt-7 px-5 py-2.5 rounded-lg bg-white text-[#0B2545] font-semibold text-sm hover:bg-slate-100 transition-colors"
          >
            <GoogleG /> Läs alla omdömen på Google <ExternalLink size={15} />
          </a>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 py-20">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6">
          {reviews.map((r, idx) => (
            <div key={idx} data-testid={`review-card-${idx}`} className="relative break-inside-avoid mb-6 bg-white rounded-2xl p-7 border border-slate-100 hover:shadow-xl transition-shadow">
              <Quote size={40} className="text-[#f0f5fb] absolute top-5 right-5" />
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={17} className={i < r.rating ? "text-[#ffce3a] fill-[#ffce3a]" : "text-slate-200 fill-slate-200"} />
                ))}
              </div>
              <p className="text-slate-600 leading-relaxed relative z-10">”{r.text}”</p>
              <div className="flex items-center gap-3 mt-6 pt-5 border-t border-slate-100">
                <span className="w-11 h-11 rounded-full bg-[#0B2545] text-[#ffce3a] flex items-center justify-center font-display font-bold">
                  {r.name.charAt(0)}
                </span>
                <div className="flex-1">
                  <div className="font-semibold text-[#0B2545]">{r.name}</div>
                  <div className="text-xs text-slate-400">{r.date}</div>
                </div>
                <span className="flex items-center gap-1 text-xs text-slate-400"><GoogleG /> Google</span>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <a
            href={googleReviews.writeUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="write-review-link"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-[#0B2545] text-white font-semibold hover:bg-[#13315C] transition-colors"
          >
            <Star size={18} className="text-[#ffce3a] fill-[#ffce3a]" /> Lämna ett omdöme på Google
          </a>
        </div>
      </section>

      <CTASection />
    </main>
  );
}
